import React, { useMemo } from "react";

const TERMS_AND_CONDITIONS_CONTENT = `Page | 2
Background
(1) Digitization Entity: [ComTech  FZCO], a company registered in the Dubai Airport Free
Zone with registration number and having its address at 9WA 138-SO-22, First Floor,
Freezone Airport Dubai, Dubai, United Arab Emirates
(2) Blockchain Platform used: XDC Blockchain Network
1 Definitions and interpretation
1.1 In these terms and conditions ("Terms"):
"Affiliate" means, with respect each party, any other person who, directly or
indirectly, Controls, is controlled by, or is under common Control with such party,
including, without limitation, any general partner, managing member, officer or
director of such party or any venture capital fund now or hereafter existing that is
Controlled by one or more general partners or managing members of, or shares the
same management or advisory company with, such party;
"Authorised Partners" has the meaning provided in clause 10.1;
"Blockchain" means a system of recording information by way of a digital ledger of
transactions that is duplicated and distributed across the entire network of computer
systems on the blockchain ;
"Financed party" has the meaning provided in clause 8.2.2(a);
"Charge Fee" has the meaning provided in clause 14.1
"Digitization Entity" means ComTech  FZCO and its affiliates and subsidiary
companies;
"Consumer" has the meaning provided in clause 19.6;
"Control" means:
(a) the power of a person (whether directly or indirectly and whether by
the ownership of share capital, the possession of voting power,
contract or otherwise) to appoint and/or remove all or such of the
members of the board or other governing body as are able to cast a
majority of the votes capable of being cast by the members of that
board or body on all, or substantially all, matters, or otherwise to
control or have the power to control the policies and affairs of that
person; and/or
(b) the holding and/or possession of the beneficial interest in and/or
the ability to exercise the voting rights applicable to shares or other
securities in any person (whether directly or indirectly or by means
of holding such interests in one or more other persons) which confer
in aggregate on the holders thereof more than fifty per cent (50%)
of the total voting rights exercisable at general meetings of that
person on all, or substantially all, matters. and "Controlling" or to
be "Controlled" shall be construed accordingly;;
Page | 3
"Conversion Notice" means [●] notice as provided in clause 9.1;
"Digital Wallet" has the meaning provided in clause 6.1;
"Exchanged Digital Gold" has the meaning provided in clause 9.1;
"Facilitation Service" has the meaning provided in clause 8.2.1
“Gold Reserves” means specific gold bullion of at least 999 purity and held by the
Digitization Entity in a custodial vault, identifiable by a unique serial number, weight
and purity for which the Digitization Entity is the representative of the Digital Gold
Holder;
"Lent Gold" has the meaning provided in clause 8.2.4;
"Margin" means [insert definition in reference to 8.2.2(e)
"Participating Digital Gold" has the meaning provided in clause 8.2.3
"Participating Digital Gold Holder" means the Digital Gold Holder who owns the
participating Digital Gold as defined in clause 8.2.4;
"Prohibited Person" means [to be provided];
"Platform" means the XDC Blockchain Network;
"Price of Gold" means [Provide the definition] as provided in 7.4;
"Redeemed Digital Gold" has the meaning provided in clause 9.1];
"Redeem Gold Bars" has the meaning as provided in clause 9.2;
"Sanctions" means any laws or regulations relating to economic or financial
sanctions, export controls, trade embargoes or restrictive measures from time to time
imposed, administered or enforced by a Sanctions Authority;
"Sanctions Authority" means the relevant authority in the UAE having jurisdiction,
including the Central bank of the UAE, the Executive Office of the Committee for Goods
Subject to Import and Export Controls or the United Nations (UN) and in each case
their respective governmental, judicial or regulatory institutions, agencies,
departments and authorities, including (without limitation) the UN Security Council or
other international authority,;
"Sanctions List" any of the lists issued or maintained by a Sanctions Authority
designating or identifying individuals or entities that are subject to Sanctions, in each
case as amended, supplemented or substituted from time to time, including (without
limitation) the Consolidated United Nations Security Council Sanctions List;
"Sanctions Proceedings" has the meaning provided in clause 17.1.5:
"Sanctions Target" means a person or entity that is:
(a) either listed on, or owned or controlled by (whether directly or
indirectly) or acting on behalf of a person listed on, a Sanctions List;
or
(b) resident, domiciled or located in, or incorporated or organised under
the laws of, a Sanctioned Territory; or
(c) otherwise identified by a Sanctions Authority as being subject to
Sanctions;
Page | 4
"Sanctioned Territory" means a country or territory that is subject to any general
financial, trade or holding restrictions or embargos under any Sanctions;
"Digital Gold" has the meaning as referred to in clause 3 of these Terms and
Conditions;
"Digital Gold Holder" means any person holding the Digital Gold;
"Terms and Conditions" means these terms and conditions;
"Transfer Fees" means the fees that the Digital Gold Holders are obliged to pay as
referred to in clause 14.2;
"Vault" has the meaning provided in clause 4.1 ;
"UAE" means the United Arab Emirates;
" XDC Blockchain Network" has the meaning defined in clause 6.1;
"Your" or "Your" means the purchaser of the Digital Gold.
1.2 The clause and paragraph headings and the table of contents used in these Terms and
Conditions are inserted for ease of reference only and shall not affect construction.
1.3 References to a Director shall include any alternate appointed to act in his place from
time to time.
1.4 References to persons shall include bodies corporate, unincorporated associations and
partnerships, in each case whether or not having a separate legal personality.
1.5 Reference to a party or parties is to a party or parties of these Terms and Conditions.
1.6 References to documents "in the agreed form" are to documents in terms agreed by
the parties and initialled on behalf of each such party for the purposes of identification
only.
1.7 References to those of the parties that are individuals include their respective legal
personal representatives.
1.8 References to "writing" or "written" includes any non-transitory form of visible
reproduction of words.
1.9 References to the word "include" or "including" (or any similar term) are not to be
construed as implying any limitation and general words introduced by the word "other"
(or any similar term) shall not be given a restrictive meaning by reason of the fact
that they are preceded or followed by words indicating a particular class of acts,
matters or things.
1.10 Except where the context specifically requires otherwise, words importing one gender
shall be treated as importing any gender, words importing individuals shall be treated
as importing corporations and vice versa, words importing the singular shall be treated
as importing the plural and vice versa, and words importing the whole shall be treated
as including a reference to any part thereof.
Page | 5
PART A:
2 Preliminary terms and conditions
2.1 These Terms apply to each and every Digital Gold Holders (also referred to as "You"
or "Your") of the Digital Gold. You should read these Terms carefully. By purchasing
Digital Gold, transferring a Digital Gold into a Digital Wallet, using Digital Gold in any
manner contemplated under these Terms or seeking to convert or redeem any Digital
Gold, you agree to these Terms and that any purchaser or other transferee of Digital
Gold shall be subject to these Terms. By purchasing Digital Gold in any way, the
purchaser (also referred to herein as “You” or “Your”) also agrees to these Terms
and that any purchaser or other transferee of Digital Gold of the user shall be subject
to these Terms.
2.2 By agreeing to these Terms, You agree to be bound by the terms and conditions of
this document and any other supporting policies and procedures as mentioned in this
document, as applicable.
3 Digital Gold
3.1 Digital Gold is a dematerialized and uncertificated Blockchain-based digital Token
generated by the Digitization Entity.
3.2 Each Digital Gold unit represents undivided ownership and specific interest in one (1)
gram of at least 999 purity gold in the Gold Reserves.
3.3 Digital Gold is not money or legal tender and is not a monetary instrument.
3.4 Digital Gold is not intended to be a "security" for the purposes of any securities
regulations in the UAE or any other jurisdiction.
3.5 The physical Gold Reserves will be of standardised 1 kg bars of 999 purity from
internationally accepted refineries. The gold bars constituting the Gold Reserves would
be distinctly identifiable through their bar number. Digital Gold will be 100% backed
by Physical Gold Reserves at all time, however in rare cases wherein due to holiday
or logistical issues , the Digitalization Entity is not able to back it up with Gold
Reserves, it can do so subject to a maximum limit of 10kgs and it shall ensure to back
it up with the Gold Reserve within 24 hours of the next business day.
3.6 Digital Gold is held and stored by the Digitization Entity in Your name, behalf and at
Your cost in accordance with the Terms. You expressly and irrevocably appoint and
authorize the Digitization Entity for an indefinite period of time to be custodian,
administrator and holder of the specific interest in the Gold Reserves represented by
each Digital Gold unit by acting as agent in possession for You.
3.7 Delivery to You of the associated specific interest in the Gold Reserves represented by
each Digital Gold unit shall be completed upon the purchase or transfer to You of such
Digital Gold unit and Your acceptance of such delivery. Upon and following such
delivery, the Digitization Entity shall hold the Gold on Your behalf as, and for so long
as You remain the holder of Digital Gold and the underlying Gold represented thereby.
4 Storage of underlying gold and liability
4.1 The Digitization Entity shall store the Gold Reserves with custodians of international
repute in the UAE or elsewhere operating specialized high-security storage facilities
(the “Vault”). The Digitization Entity shall be entitled to store the Gold Reserves
through its Affiliates any where in the world provided it retains Control over such
Affiliate and the custody by way of contract.
Page | 6
4.2 The Digitization Entity shall insure that the Gold Reserves will be stored on a
segregated basis and will not be commingled with any other gold stored in the Vault.
4.3 The Digitization Entity will take out an [all-risk] policy on the Gold Reserves and the
Digital Gold Holder will be the beneficiary of such policy by virtue of owning the Digital
Gold unit.
4.4 The Digital Gold Holder shall provide a periodic statement from the custodian of the
Gold Reserves showing the details of the Gold reserves in the Vault.
4.5 Information about the custodians and the Vaults, where the Gold Reserves are stored,
is available on the website of the Digitalization Entity.
5 Platform and technology
5.1 The Digitization Entity has developed the Digital Gold unit, the wallet transfer and
blockchain ledger infrastructure on the XDC Blockchain Network, located at
https://xinfin.org/index.
5.2 The Digital Gold Holder shall be able to access the records and details of the Digital
Gold and various transactions using the Ledger Data Store into the XDC Blockchain
Network.
6 Digital custody of Digital Gold
6.1 The Digital Holder will be entitled to store the Digital Gold using Digital Gold wallet
provided by the Digitalization entity through its App and various other Digital Wallets
as listed on the website of the Digitization Entity:
The Digital Gold Holder Acknowledges that the list of Digital Wallets listed on the
website of the Digitization Entity may change from time to time without notice.
7 Listing and trading of Digital Gold
7.1 The Digitization Entity has listed the Digital Gold on the its trading platform via app
and web access and any other portal as listed on the website of the Digitization Entity.:
7.2 The Digital Gold Holder acknowledges that the above list of portals on the website of
the Digitization Entity may change from time to time without notice by the Digitization
Entity from time to time.
7.3 The Digitization Entity will take all commercially reasonable steps to maintain the
listing of Digital Gold on its trading platform via app and web access.
7.4 The Digital Gold Holder acknowledges that it will be required to register with the
Digitalization entities Trading platform and comply with all terms and conditions of the
platform in order to trade Digital Gold on that platform, including without limitation,
"Know-Your-Client", anti-money laundering and sanctions related obligations.
7.5 The Digitization Entity will conduct "know your client" checks in accordance with
applicable regulations on persons depositing the Gold Reserves.
7.6 The Digital Gold Holder acknowledges that the value of Digital Gold unit relies
substantially on the value of gold. The ("Price of Gold") is subject to market
conditions and does fluctuate against currency and may result in a loss against
currency.
Page | 7
7.7 Any trade of Digital Gold shall be accompanied by a transfer of the Digital Gold unit.
A person who does not own a Digital Gold unit shall not be entitled to sell Digital Gold
by way of a future trade or short sale or similar speculative trade.
7.8 The seller of the Digital Gold by way of placing a sale order on the Trading platform
serves as an offer notice the Digitalization entity to sell its physical gold in the form
of Digital Gold units and such sale shall be completed upon the execution of the trade
and receipt of funds into its account with the Trading Platform.
7.9 The Buyer of Digital Gold by way of placing of a buy order on the Trading Platform
shall serve as an acceptance notice to the Digitalization entity to buy the physical gold
in the form of Digital Gold units and such sale shall be completed upon the execution
of the trade and receipt of Digital Gold units into its wallet with the Trading Platform.
8 Redemption of Digital Gold to physical gold
8.1 You may instruct the Digitization Entity to convert Digital Gold to physical gold from
the Gold Reserves of a minimum quantity of one kilogram and in further
denominations of one kilogram each ("Redeemed Digital Gold Units") by giving a
notice ("Conversion Notice").
8.2 The Digitization Entity shall procure the release of the underlying Gold Reserves of the
Redeemed Digital Gold Units ("Redeemed Gold Bars"), less applicable fees, and to
procure Your collection of the Redeemed Gold Bars in person in the Vault or request
delivery of the Commodity to You at Your own cost and expense (certain limitations
apply) on the terms and conditions set out herein. The Digitization Entity may require
suitable identification documents and / or authorization of the person collecting the
Redeemed Gold Bars and require the person collecting the Redeemed Gold Bars to
execute suitable receipt and discharge documents.
8.3 Once You submit the Conversion Notice You simultaneously instruct and authorize the
Digitization Entity to cancel (burn) the Redeemed Digital Gold Units.
8.4 Upon completion of the redemption, the Redeemed Digital Gold Units will be cancelled
(burnt) by the Digitization Entity.
9 Exchange of Digital Gold units for Gold with Authorized Partners
9.1 The Digitization Entity may from time-to-time partner with jewellers or bullion
providers ("Authorized Partners") which Authorized Partners would be entitled to
collect Digital Gold units from Digital Gold Holders of a quantity of not less than 1
gram ("Exchanged Digital Gold Units") and exchange it for gold or jewellery as may
be agreed between the Digital Gold Holder and the Authorized Partner.
9.2 The Authorized Partner shall become the owner of the Exchanged Digital Gold Unit
and will in turn can deal with the Exchanged Digital Gold Unit on the terms herein or
otherwise on terms agreed with the Digitization Entity.
10 Security
10.1 [The Digital Gold Holder acknowledges that the Digital Gold unit may be subject to
expropriation and or/theft. Hackers or other malicious groups or organizations may
attempt to interfere with the Digital Gold Unit and/or the XDC Blockchain Network
and/or the Trading Platforms in which Digital Gold listed in a variety of ways, including,
but not limited to, malware attacks, denial of service attacks, consensus-based
attacks, Sybil attacks, smurfing and spoofing. Furthermore, since the XDC Blockchain
Network and the exchanges rests on open-source software and the Digital Gold units
are based on open source software, there is the risk that smart contracts may contain
intentional or unintentional bugs or weaknesses which may negatively affect Digital
Gold or result in the loss of Your Digital Gold unit, the loss of Your ability to access or
Page | 8
control Your Digital Gold unit. In the event of such a software bug or weakness, there
may be no remedy and You are not guaranteed any remedy, refund or compensation.]
11 Fee/commissions/charges
11.1 The Digitization Entity will be entitled to ("Charge Fees") as set out in [●
https://www.comtechgold.com/fee-structure.html . These fees:
11.1.1 Fees on Creation or Redemption
11.1.2 Trading fees;
11.1.3 Fees for exchange with Authorized partners;
11.1.4 Fees on transfer;
11.1.5 Delivery fees for Redeemed Gold Bars;
11.1.6 Storage fees, which will include costs for the Vaults and insurance;
11.1.7 Financing fees where applicable
11.1.8 Facilitation fees for various services offered
11.2 The Transfer Fees are an obligation of all Digital Gold Holders. By purchasing Digital
Gold, You agree to assign the obligation to pay any and all fees tied to the Digital
Gold to subsequent holders of such Digital Gold, and by receiving transfers of Digital
Gold, You agree to accept the assignment of such obligation.
11.3 The Digitization Entity may offer incentives or reduced fees to certain clients at the
Digitization Entity's sole discretion.
11.4 Right to Change Fees and Fee Structure
The Digitization Entity reserves the right to change or modify its fee structure or
increase any of the fees at any time and from time to time. Any such changes,
modifications or increases will be notified on the website and effective upon posting
such changes, modifications or increases on the Digitization Entity's site. Your first use
of Digital Gold following the posting on the Site of any changes to the fees will
constitute Your acceptance of such changes.
[If You do not agree to the posted changes, the Digital Gold Holder can sell the
Digital Gold unit or redeem the Digital Gold in accordance with such these Terms.
12 Prohibited persons and purposes
12.1 The Digitization Entity shall be entitled to follow any rules, regulations, orders, awards,
directions from a Sanctions Authority, legislative body, regulator, court. tribunal or
any other authority having jurisdiction in connection with any Digital Gold Holder or
Digital Gold unit.
13 Warranties
13.1 You warrant the following:
13.1.1 You have a legal capacity to enter into transactional documents to purchase
Digital Gold under the applicable laws, and you have it has full power and
authority to carry out the actions contemplated in such transactional
documents;
Page | 9
13.1.2 You are not declared bankrupt and no application is made to court, or an
order is made, for the appointment of an administrator (or equivalent) in
relation to Your assets;
13.1.3 You are not a Prohibited Person;
13.1.4 You are not contravening any applicable Sanctions;
13.1.5 You are not engaged or involved in, or otherwise subject to, any of the
following matters ("Sanctions Proceedings"):
(a) any litigation, arbitration, settlement, or other proceedings
(including alternative dispute resolution, criminal and administrative
proceedings) in any jurisdiction; or
(b) any investigation, inquiry, enforcement action (including the
imposition of fines or penalties) by any governmental,
administrative, regulatory or similar body or authority in any
jurisdiction,
in each case relating to, or in connection with, any actual or alleged contravention of
applicable Sanctions;
13.1.6 No Sanctions Proceedings have been threatened or are pending against you
and there are no circumstances likely to give rise to any such Sanctions
Proceedings against You.
13.1.7 You are not:
(a) Sanctions Target; or
(b) engaging, or has engaged, in any conduct, operations, transactions
or dealings that could reasonably be expected to result in it
becoming a Sanctions Target.
13.1.8 You have not conducted or engaged, or is currently conducting or engaging,
(in each case directly or, so far as the Seller is aware, indirectly) in any
operations, activities, transactions or dealings with, or for the benefit of, a
Sanctions Target; and
13.1.9 You are not operating and have no dealings in a Sanctioned Territory, where
such operations or dealings contravenes applicable Sanctions.
14 Disclaimers/risks/indemnities
14.1 We recommend that You ensure that computers and other devices used to access
Digital Gold run up-to-date anti-virus software as a precaution, and You are advised
to virus-check any materials downloaded and regularly check for the presence of
viruses and other malicious code.
14.2 We will not be liable for any loss or damage caused by a virus or other technologically
harmful material that may infect Your computer equipment, computer programs, data
or other proprietary material due to Your use in connection with Digital Gold or from
any website linked to it.
14.3 No warranty is given in respect of the compliance of Digital Gold or these terms with
the provisions of Shari'ah. The Digital Gold Holder warrants that it has made its own
determination on the compliance with Shari'ah.
Page | 10
14.4 The Digital Gold Holder confirms that it does not have any objection, nor will it raise
any objections, as to matters of Shari'ah compliance in respect of or otherwise in
relation to any of the provisions of these Terms or the Digital Gold or any matter
related hereto.
15 Limitation of Liability
15.1 It is a condition of owning Digital Gold that You accept and agree we shall not be liable
for any harmful effect that holding the Digital Gold unit may have on You, and You
agree that You own the Digital Gold units entirely at Your own risk.
15.2 Without limitation to the generality of the foregoing and any specific limitations
contained in these Terms, whether in contract, tort (including, without limitation,
negligence), breach of statutory duty, or otherwise:
15.2.1 we will not be liable to You for any loss or damage arising under or in
connection with:
(a) use of, or inability to use, any third party's services, software or
facilities including the XDC Blockchain Network, any Trading
Platform, or any digitals wallets;
(b) use of or reliance on any content displayed on or produced via the
Digitization Entity's website;
(c) the acts or omissions of any other owners of Digital Gold Holders or
Financed Party; or
15.3 The Digitization Entity will have no liability to You for any indirect or consequential
losses of any kind or for any loss of revenue, profit, business opportunity, contracts,
data or goodwill (whether direct or indirect) arising out of or in connection with these
Terms and/or the Digital Gold; and
15.4 The Digitization Entity's total liability to You in respect of any and all loss and/or
damage arising out of or in connection with these Terms and/or Digital Gold and/or
the Gold reserves shall in no circumstances exceed the fees received by the
Digitization Entity.
15.5 Except as expressly set out in these Terms and to the maximum extent permitted by
law, the Digitization Entity makes no representations, warranties or guarantees of any
kind in respect of Digital Gold and all conditions, warranties and representations
express or implied are hereby excluded to the full extent permitted by law.
15.6 Nothing in these Terms and Conditions is intended to remove Your rights under the
laws applicable to You as to a consumer in any jurisdiction, including to statutory
guarantees that may apply to Your use of the Platform under applicable jurisdiction.
If we are entitled to limit the remedies available to You for breach of such guarantees
udder such jurisdiction, we expressly limit our liability as set out in this section to the
maximum extent permitted by laws of such jurisdiction. Any warranties, guarantees
and conditions may apply that we cannot legally exclude, then to the extent permitted
by law of the relevant jurisdiction, we limit our liability for any claims under those
warranties, guarantees or conditions to either supplying You the services again or
paying the cost of having the services supplied again.
16 Termination or Suspension
16.1 These Terms will automatically cease to apply to a Digital Gold Holder upon the sale
of Digital Gold or Redemption of Digital Gold.
Page | 11
16.2 The Digitization Entity shall be entitled to suspend the listing or trading of Digital Gold
and/or the redemption provisions of these Terms in case of a force majeure event or
on account of any technical issue faced or otherwise.
17 General
17.1 In the event that any one or more of the provisions contained in these Terms and
Conditions shall for any reason be held to be illegal, unenforceable or invalid, such
illegality, unenforceability or invalidity shall not affect any other provision of these
Terms and Conditions, but these Terms and Conditions shall be reformed and
construed as if such illegal or unenforceable or invalid provision had never been
contained herein and such provision shall be reformed so that it would be legal,
enforceable and valid to the maximum extent permitted by applicable law.
17.2 Any variation of these Terms and Conditions is valid only if approved by the Digitization
Entity and comminated to You in writing These Terms and Conditions and the
documents referred to or incorporated in it constitute the entire agreement between
the Digitization Entity and You relating to the subject matter of Terms and Conditions
and supersedes and extinguishes any prior drafts, agreements, undertakings,
representations, warranties and arrangements of any nature whatsoever, whether or
not in writing.
17.3 You hereby acknowledge and agree that you have not accepted these Terms and
Conditions in reliance on any statement or representation of any person other than as
expressly incorporated in these Terms and Conditions and the documents referred to
or incorporated in these Terms and Conditions.
17.4 Nothing contained in these Terms and Conditions or in any other document referred
to or incorporated in it shall be read or construed as excluding any liability or remedy
as a result of fraud.
17.5 The Digitization Entity shall be entitled to assign these Terms to an Affiliate from time
to time without the consent of the Digital Gold Holder.
17.6 These Terms and Conditions and any non-contractual obligations arising from or in
connection with it shall in all respects be governed by and interpreted in accordance
with English law.
17.7 You agree that any dispute arising from or in connection with these Terms and
Conditions, including any question regarding its existence, validity or termination,
shall be decided by arbitration under the arbitration rules of the London Court of
International Arbitration, which are deemed to be incorporated by reference to these
Terms and Conditions. The number of arbitrations shall be 1 (one). The legal seat, or
legal place of arbitration shall the Dubai International Financial Centre, Dubai, UAE.
The Language to be used in the arbitration shall be English.
18 Shariah Compliance
18.1 Each of the parties hereby agrees that it has accepted the Shariah compliant nature
of the product to which it is a party and, to the extent permitted by law, further agrees
that:
(a) it has undertaken its own independent assessment to confirm and verify on the
Shariah compliance nature of the product without relying on the Shariah
representation made by any other party including of the Digitalization Entity.
(b) it shall not claim that any of its obligations under the product documents to
which it is a party (or any provision thereof) is ultra vires or not compliant with the
principles of Shari'ah;
Page | 12
(c) it shall not take any steps or bring any proceedings in any forum to challenge
the Shariah compliance of the product documents to which it is a party; and
(d) none of its obligations under the product documents to which it is a party shall
in any way be diminished, abrogated, impaired, invalidated or otherwise adversely
affected by any finding, declaration, pronouncement, order or judgment of any court,
tribunal or other body that the Transaction Documents to which it is a party are not
compliant with the principles of Shari'ah.
19 Waiver of Interest
19.1 Each party irrevocably agrees that no interest will be payable or receivable under or
in connection with this product and if it is determined that any interest is payable or
receivable in connection with this product by a party, whether as a result of any
arbitral or judicial award or by operation of any applicable law or otherwise, such party
agrees to waive any rights it may have to claim or receive such interest and agrees
that if any such interest is actually received by it, it shall hold such amount in a
suspense account and promptly donate the same to a registered or otherwise officially
recognised charitable organisation.
19.2 For the avoidance of doubt, nothing in this Clause shall be construed as a waiver of
rights in respect of a profit or principal of any kind howsoever described payable by
the relevant obligor (in any capacity) or the Digitalization Entity (in any capacity)
pursuant to the product documents and/or the Terms and Conditions herein and/or
any other document or agreement, howsoever such amounts may be described or recharacterised by any court or arbitral tribunal.
Page | 13
PART B: (This part shall be outside the scope of Shariah Compliance features
and CGO holders opting for Financing acknowledge that the process of Financing
of Digital Gold does not fall under the Shariah Certification)
20 Financing
20.1 Digital Gold as Security
The Digitization Entity shall use its reasonable efforts to engage with banks and or
financial institutions to have them accept Digital Gold as collateral and security by way
of providing information relating to Digital Gold and the Digitization Entity's
operations.
20.2 Digital Gold financed to third parties
The Digitization Entity may from time to time facilitate the financing of the underlying
Gold Reserves for an identified pool of Digital Gold units to commercial parties in the
gold and jewellery business who finance gold for their business purposes for periods
of up to 6 months and provide a cash margin or profit together with the return of gold.
The Digitization Entity from time to time may offer such facilitation service to Digital
Gold Holder on the following terms:
20.2.1 The Digitization Entity will be entitled to offer the Facilitation Service at its
discretion and is not obliged to offer it to all Digital Gold holder or at all.
20.2.2 The Digitization Entity will notify any such financing opportunity to the Digital
Gold Holders from time to time, which notification would include:
(a) Details of the Financed party ("Financed Party");
(b) The amount of gold to be financed from the Gold Reserves;
(c) The equivalent number of Digital Gold units that would be needed
to participate in this arrangement;
(d) The term of the financing arrangement;
(e) The return / profit that the Financed Party would pay ("Margin");
(f) Any other terms.
20.2.3 The Digitization Entity may then pool the necessary Digital Gold units
required for the proposed arrangement ("Participating Digital Gold
Units") and offer the underlying Gold Reserves to the Financed Party.
20.2.4 The Digital Gold Holder(s) who own the Participating Digital Gold Unit
("Participating Digital Gold Holders") and the Financed Party will enter
into the relevant financing contracts. Participating in the participation
agreement, constitutes an instruction by the Digital Gold Holders to the
Digitization Entity to put a lien or block on the Participating Digital Gold Units
and instruct the Digitization Entity to release the underlying Gold Reserves
to the Financed Party ("Financed Gold"). The participating Digital Gold
Holders will authorize the Digitization Entity to collect the same quantity and
quality as the Financed Gold from the Financed Party together with the
Margin.
20.2.5 On return of the Financed Gold and receipt of Margin, the Digitization Entity
shall:
(a) deduct its fees from the Margin received;
Page | 14
(b) deposit the returned gold to the Vault;
(c) release the block on the Participating Digital Gold Units.
The Digitization Entity will not be liable to the Financed Party or the Participating
Digital Gold Holder and will simply facilitate the transaction. The Participating Digital
Gold Holders will take the risk under the proposed transaction.`;

const Termsandconditions = () => {
  const content = TERMS_AND_CONDITIONS_CONTENT;

  const headingStyle = {
    fontWeight: 600,
  };

  const bulletStyle = {
    fontWeight: 500,
    marginLeft: 55,
  };

  const subheadingStyle = {
    fontWeight: 500,
  };

  const blocks = useMemo(() => {
    const cleaned = (content || "")
      .replace(/\r\n/g, "\n")
      .replace(/^\s*Page\s*\|\s*\d+\s*$/gim, "")
      .replace(/\n{3,}/g, "\n\n")
      .trim();

    if (!cleaned) return [];

    const lines = cleaned.split("\n");
    const results = [];
    let currentParagraphLines = [];
    let currentBullet = null;

    const flushParagraph = () => {
      if (currentParagraphLines.length === 0) return;
      const joined = currentParagraphLines
        .map((l) => l.trim())
        .filter(Boolean)
        .join(" ");
      if (joined) results.push({ type: "paragraph", text: joined });
      currentParagraphLines = [];
    };

    const flushBullet = () => {
      if (!currentBullet) return;
      const joined = currentBullet.lines
        .map((l) => l.trim())
        .filter(Boolean)
        .join(" ");
      if (joined) results.push({ type: "bullet", prefix: currentBullet.prefix, text: joined });
      currentBullet = null;
    };

    for (const rawLine of lines) {
      const trimmed = rawLine.trim();

      if (!trimmed) {
        flushBullet();
        flushParagraph();
        continue;
      }

      if (/^Page\s*\|/i.test(trimmed)) continue;

      const isHeading =
        /^(Background|PART\s+[A-Z]:)\s*$/i.test(trimmed) ||
        /^\d+\s+/.test(trimmed);

      const isSubheading = /^\d+(\.\d+)+\s+/.test(trimmed);

      const bulletStartMatch = trimmed.match(
        /^(•|\(\d+\)|\([a-z]\))\s+(.+)$|^(["“][^"”]+["”]\s+(?:means|has the meaning)\b.*)$/i
      );
      const isBulletStart = Boolean(bulletStartMatch);

      if (isSubheading) {
        flushBullet();
        flushParagraph();
        results.push({ type: "subheading", text: trimmed });
        continue;
      }

      if (isHeading) {
        flushBullet();
        flushParagraph();
        results.push({ type: "heading", text: trimmed });
        continue;
      }

      if (isBulletStart) {
        flushParagraph();
        flushBullet();

        if (bulletStartMatch[1]) {
          currentBullet = { prefix: bulletStartMatch[1], lines: [bulletStartMatch[2]] };
        } else {
          currentBullet = { prefix: "•", lines: [bulletStartMatch[3]] };
        }
        continue;
      }

      if (currentBullet) {
        currentBullet.lines.push(trimmed);
      } else {
        currentParagraphLines.push(trimmed);
      }
    }

    flushBullet();
    flushParagraph();
    return results;
  }, [content]);

  const renderHighlightedText = (text) => {
    const normalized = (text || "").replace(/\s+/g, " ").trim();
    const definitionMatch = normalized.match(/^["“]([^"”]+)["”]\s+(means|has the meaning)\b(.*)$/i);
    if (definitionMatch) {
      const term = definitionMatch[1].trim();
      const verb = definitionMatch[2];
      const rest = definitionMatch[3] || "";
      return (
        <>
          <b>{`"${term}"`}</b> {verb}
          {rest}
        </>
      );
    }

    const body = normalized;
    const labelMatch = body.match(/^(.{2,40}?):\s*(.+)$/);
    const looksLikeUrl = /^https?:\/\//i.test(body);

    if (labelMatch && !looksLikeUrl) {
      const label = labelMatch[1].trim();
      const rest = labelMatch[2].trim();
      return (
        <>
          <b>{label}:</b> {rest}
        </>
      );
    }

    return normalized;
  };

  const getBulletRenderStyle = (prefix) => {
    const base = {
      ...bulletStyle,
      whiteSpace: "normal",
    };

    if (/^\([a-z]\)$/i.test(prefix) || /^\(\d+\)$/.test(prefix)) {
      return {
        ...base,
        marginLeft: 75,
        paddingLeft: 32,
        textIndent: -32,
      };
    }

    return {
      ...base,
      paddingLeft: 22,
      textIndent: -22,
    };
  };

  return (
    <div>
      <div className="main-contain pt-5 mt-5 mb-5" style={{ textAlign: "justify" }}>
        <section>
          <div className="iq-banner-2">
            <div className="banner-info">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-11">
                    <div className="banner-text iq-font-white">
                      <h2 className="h2 text-primary">Terms & Conditions</h2>
                      <p className="fs-18">ComTech  Digital Gold</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="hero-internal-separator mt-5"></div>
          </div>

          <section className="iq-product-description overview-block-pt pt-0">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-11">

                  {blocks.length > 0 ? (
                    blocks.map((block, index) => {
                      if (block.type === "heading") {
                        return (
                          <p key={index} className="mt-4 mb-2 fs-22" style={headingStyle}>
                            {block.text}
                          </p>
                        );
                      }

                      if (block.type === "subheading") {
                        return (
                          <p key={index} className="mt-4 mb-2 fs-18" style={subheadingStyle}>
                            {renderHighlightedText(block.text)}
                          </p>
                        );
                      }

                      if (block.type === "bullet") {
                        return (
                          <p key={index} className="fs-18" style={getBulletRenderStyle(block.prefix)}>
                            <span>{block.prefix} </span>
                            {renderHighlightedText(block.text)}
                          </p>
                        );
                      }

                      return (
                        <p key={index} className="fs-18">
                          {renderHighlightedText(block.text)}
                        </p>
                      );
                    })
                  ) : (
                    <p className="fs-18">{content}</p>
                  )}
                  <div className="mt-5">
                    <p className="fs-18">To download the full Terms and Conditions, please <a href="/assets/pdf/Terms_and_Conditions.pdf" target="_blank" rel="noreferrer" style={{color: '#007bff', textDecoration: 'underline'}}>click here</a>.</p>
                    <p className="mt-4 fs-18">Last Updated: March 12, 2026</p>
                  </div>

                </div>
              </div>
            </div>
          </section>

        </section>
      </div>
    </div>
  );
};

export default Termsandconditions;
